import { render, staticRenderFns } from "./WaBtn.vue?vue&type=template&id=2f32af17&scoped=true"
var script = {}
import style0 from "./WaBtn.vue?vue&type=style&index=0&id=2f32af17&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2f32af17",
  null
  
)

export default component.exports